import moment from 'moment';

import {Moment} from '../../../typings/globals/sam';

export class UuidLicense {
  public uuid: string;
  public tenant: string;
  public gestion: string;
  public ipAddress: string;
  public expirationDate: Moment;
  public status: string;

  constructor(data: Partial<UuidLicense> = {}) {
    this.tenant = data.tenant?.toLowerCase() ?? '';
    this.uuid = data.uuid ?? '';
    this.gestion = data.gestion ?? '';
    this.ipAddress = data.ipAddress ?? '';
    this.expirationDate = data.expirationDate
      ? moment(data.expirationDate)
      : moment();
    this.status = data.status ?? 'ACTIVE';
  }

  /**
   * Make sure that the tenant id is in lowercase
   *
   * @static
   * @param {TenantLicense} tenant
   */
  public static format(tenant: UuidLicense): UuidLicense {
    tenant.tenant = tenant.tenant?.toLowerCase() ?? '';
    return tenant;
  }
}
